import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpRequestService } from '../../utilities/http/request.utilities';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VideoService {
  constructor(private httpRequestService: HttpRequestService) {}

  async getPresignedUrl(docPath: string): Promise<string> {
    const result = await firstValueFrom(
      this.httpRequestService.request<{ download_url: string }>(
        'GET',
        environment.integrations.videoPresignedUrl,
        undefined,
        { url: docPath }
      )
    );
    console.log(
      `Received presigned URL for video: ${docPath}, URL: ${result}`
    )
    return result.download_url;
  }
}